/** @module root/components/accreditation/improvement */

import * as STATES                      from './improvement.states';
import { IDS }                          from './improvement-action-id.constants';
import { improvementAction }           from './action/action.component';
import { improvementActions }           from './list/list.component';
import { improvementActionsGrid }       from './list/list-grid.component';
import { improvementActionPlan }        from './action-plan/action-plan.component';
import { improvementStepsGrid }         from './action-plan/steps-grid.component';
import { improvementStep }              from './step/step.component';
import { addAction }               from './add-action/add-action.component';
import { addActionStepsGrid }      from './add-action/add-action-steps-grid.component';

export const IMPROVEMENT_MODULE = angular.module(
    'migration.accreditation.improvement',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
        Object.values({
            ...STATES,
        }).map(state => stateRegistry.register(state));
    }]
).component({
    improvementAction,
    improvementStepsGrid,
    improvementActions,
    improvementActionsGrid,
    improvementActionPlan,
    improvementStep,
    addAction,
    addActionStepsGrid

}).run(['$templateCache', ({ put }) => {
    put(IDS.app_accreditation_scheme_improvement_list,     '<improvement-actions></improvement-actions>');
    put(IDS.app_accreditation_scheme_improvement_action,   '<improvement-action></improvement-action>');
    put(IDS.app_accreditation_scheme_improvement_action_plan, '<improvement-action-plan></improvement-action-plan>');
    put(IDS.app_accreditation_scheme_improvement_step,     '<improvement-step></improvement-step>');
    put(IDS.app_accreditation_scheme_improvement_add_action,'<add-action></add-action>');
    put('../../improvement-actions/list/list-grid-filter.html', require('./list/list-grid-filter.html'));
}]);
